import {UserOPEEnum} from "./UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";


class O {

}

/**
 * O Inner Class
 */
class I {
  id!: number;
}


/**
 * GetTransportItemDetailCB class
 */
export class DelUserCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.DelUser);
    this.i = new I();
    this.o = new O();
  }

}
